(function(){
  'use strict';
  var D = window.DM140; if(!D) return;
  var $ = function(id){ return document.getElementById(id); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;

  var colors = [], colorThumb = {};
  if(D.hasColor){
    D.variants.forEach(function(v){ if(colors.indexOf(v.c) === -1){ colors.push(v.c); colorThumb[v.c] = v.thumb; } });
  }
  function find(c,s){ for(var i=0;i<D.variants.length;i++){ var v=D.variants[i]; if(v.c===c && v.s===s) return v; } return null; }
  function firstAvailSize(c){ for(var i=0;i<D.sizes.length;i++){ var v=find(c,D.sizes[i]); if(v && v.a) return D.sizes[i]; } return D.sizes[0]; }
  var initial = null;
  for(var i=0;i<D.variants.length;i++){ if(D.variants[i].a){ initial = D.variants[i]; break; } }
  if(!initial) initial = D.variants[0];
  var state = { c: initial ? initial.c : '', s: initial ? initial.s : D.sizes[0], q: 1 };

  /* ---- gallery slider ---- */
  var track = $('dm-gal-track');
  var slides = track ? Array.prototype.slice.call(track.children) : [];
  var dotsWrap = $('dm-gal-dots');
  var dots = [];
  if(dotsWrap && slides.length > 1){
    slides.forEach(function(_, i){
      var d = document.createElement('button');
      d.type='button'; d.className='dm-gal__dot' + (i===0?' is-active':'');
      d.addEventListener('click', function(){ goTo(i); });
      dotsWrap.appendChild(d); dots.push(d);
    });
  }
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('#dm-thumbs .dm-gal__thumb'));
  thumbs.forEach(function(t, i){ t.addEventListener('click', function(){ goTo(i); }); });
  function goTo(i){ if(!track) return; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); setActive(i); }
  function setActive(i){
    dots.forEach(function(d, di){ d.classList.toggle('is-active', di===i); });
    thumbs.forEach(function(t, ti){ t.classList.toggle('is-active', ti===i); });
  }
  if(track){
    var raf = null;
    track.addEventListener('scroll', function(){
      if(raf) return;
      raf = requestAnimationFrame(function(){
        raf = null;
        var i = Math.round(track.scrollLeft / track.clientWidth);
        i = Math.max(0, Math.min(slides.length - 1, i));
        setActive(i);
      });
    }, {passive:true});
  }

  /* ---- color swatches (variant mode) ---- */
  var swWrap = $('dm-swatches');
  if(D.hasColor && swWrap){
    colors.forEach(function(c){
      var b = document.createElement('button');
      b.type='button'; b.className='dm-swatch'; b.setAttribute('aria-label', D.colorLabels[c]||c);
      var im = document.createElement('img'); im.src = colorThumb[c]; im.alt = D.colorLabels[c]||c; im.loading='lazy';
      b.appendChild(im);
      b.addEventListener('click', function(){ setColor(c); });
      b.dataset.c = c; swWrap.appendChild(b);
    });
  }

  /* ---- size pills ---- */
  var szWrap = $('dm-sizes');
  D.sizes.forEach(function(s){
    var b = document.createElement('button');
    b.type='button'; b.className='dm-size'; b.textContent = s; b.dataset.s = s;
    b.addEventListener('click', function(){ if(b.classList.contains('is-out')) return; setSize(s); });
    szWrap.appendChild(b);
  });

  var stickyImg = $('dm-sticky-img');

  /* ---- bundle (1/2/3 par) ---- */
  var bwrap = $('dm-bundle');
  var TIERS = (D.bundle && D.bundle.tiers) || [[1,0]];
  function fmtC(cents){
    try { return new Intl.NumberFormat(document.documentElement.lang || 'sv', {style:'currency', currency: D.cur || 'SEK', minimumFractionDigits:0, maximumFractionDigits:0}).format(cents/100); }
    catch(e){ return Math.round(cents/100) + ' ' + (D.cur || 'kr'); }
  }
  function buildBundle(){
    if(!bwrap) return;
    var v = find(state.c, state.s);
    var pc = v ? v.pc : (D.variants[0] ? D.variants[0].pc : 0);
    bwrap.innerHTML = '';
    TIERS.forEach(function(t){
      var q = t[0], pct = t[1];
      var was = pc * q;
      var tot = Math.round(was * (100 - pct) / 100);
      var el = document.createElement('button');
      el.type = 'button';
      el.className = 'dm-bopt' + (state.q === q ? ' is-active' : '');
      var html = '';
      if(pct > 0){
        var isPop = D.bundle && q === D.bundle.popular;
        html += '<span class="dm-bopt__badge' + (isPop ? ' dm-bopt__badge--gold' : '') + '">' + (isPop ? D.txt.pop : D.txt.save + ' ' + pct + '%') + '</span>';
      }
      html += '<span class="dm-bopt__qty">' + q + ' ' + (q > 1 ? D.txt.pairs : D.txt.pair) + '</span>';
      if(pct > 0){ html += '<s class="dm-bopt__was">' + fmtC(was) + '</s>'; }
      html += '<span class="dm-bopt__price">' + fmtC(tot) + '</span>';
      if(pct > 0){ html += '<span class="dm-bopt__per">' + fmtC(Math.round(tot / q)) + ' ' + D.txt.per + '</span>'; }
      el.innerHTML = html;
      el.addEventListener('click', function(){ state.q = q; buildBundle(); });
      bwrap.appendChild(el);
    });
  }

  function setColor(c){
    state.c = c;
    if(swWrap){ Array.prototype.forEach.call(swWrap.children, function(b){ b.classList.toggle('is-active', b.dataset.c===c); }); }
    var cn = $('dm-color-name'); if(cn) cn.textContent = D.colorLabels[c]||c;
    var v = find(c, state.s);
    if(!v || !v.a){ state.s = firstAvailSize(c); }
    var vv = find(c, state.s);
    if(vv && stickyImg) stickyImg.src = vv.thumb;
    goTo(colors.indexOf(c));
    refreshSizes(); setSize(state.s);
  }
  function refreshSizes(){
    Array.prototype.forEach.call(szWrap.children, function(b){
      var v = find(state.c, b.dataset.s);
      b.classList.toggle('is-out', !v || !v.a);
    });
  }
  function setSize(s){
    state.s = s;
    Array.prototype.forEach.call(szWrap.children, function(b){ b.classList.toggle('is-active', b.dataset.s===s); });
    var sn = $('dm-size-name'); if(sn) sn.textContent = s;
    var d = D.sizeData[D.sizes.indexOf(s)];
    var sh = $('dm-sizehint');
    if(d && sh){ sh.textContent = d.age + ' · ' + D.txt.len + ' ' + d.len + ' · ' + D.txt.calf + ' ' + d.calf; }
    var v = find(state.c, s);
    var atc = $('dm-atc'), lbl = $('dm-atc-label'), kl = $('dm-klarna');
    if(v && v.a){ atc.disabled = false; if(kl) kl.disabled = false; lbl.textContent = D.txt.atc; var pr = $('dm-price'); if(pr) pr.textContent = v.p; }
    else { atc.disabled = true; if(kl) kl.disabled = true; lbl.textContent = D.txt.soldout; }
    var sub = $('dm-sticky-sub');
    if(sub){ sub.textContent = (state.c ? (D.colorLabels[state.c]||state.c) + ' · ' : '') + s + ' · ' + (v?v.p:''); }
    var sbtn = $('dm-sticky-atc'); if(sbtn) sbtn.disabled = !(v && v.a);
    buildBundle();
  }

  /* ---- add to cart ---- */
  var addedTimer = null;
  function rootUrl(){ return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/'; }
  function addToCart(goCheckout){
    var v = find(state.c, state.s); if(!v || !v.a) return;
    var atc = $('dm-atc'), lbl = $('dm-atc-label');
    atc.disabled = true;
    fetch(rootUrl()+'cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: v.id, quantity: state.q || 1 })
    }).then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
    .then(function(){
      if(goCheckout === true){ window.location.href = D.checkoutUrl; return; }
      atc.classList.add('is-added'); lbl.textContent = D.txt.added;
      if(window.AWCart){ window.AWCart.open(); }
      clearTimeout(addedTimer);
      addedTimer = setTimeout(function(){ atc.classList.remove('is-added'); lbl.textContent = D.txt.atc; atc.disabled = false; }, 1600);
    })
    .catch(function(){ atc.disabled = false; lbl.textContent = D.txt.atc; });
  }
  $('dm-atc').addEventListener('click', function(){ addToCart(false); });
  var kl = $('dm-klarna'); if(kl) kl.addEventListener('click', function(){ addToCart(true); });
  var sbtn = $('dm-sticky-atc'); if(sbtn) sbtn.addEventListener('click', function(){ addToCart(false); });

  /* ---- review carousel ---- */
  var rtrack = $('dm-revtrack');
  function revStep(dir){ if(!rtrack) return; var card = rtrack.querySelector('.dm-rev'); var w = card ? card.offsetWidth + 16 : 320; rtrack.scrollBy({left: dir*w, behavior:'smooth'}); }
  var rp = $('dm-rev-prev'), rn = $('dm-rev-next');
  if(rp) rp.addEventListener('click', function(){ revStep(-1); });
  if(rn) rn.addEventListener('click', function(){ revStep(1); });

  /* ---- sticky bar ---- */
  var sticky = $('dm-sticky'), mainAtc = $('dm-atc');
  if('IntersectionObserver' in window && sticky && mainAtc){
    new IntersectionObserver(function(en){
      en.forEach(function(x){
        var show = x.boundingClientRect.top < 0 && !x.isIntersecting;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
      });
    }, {threshold: 0}).observe(mainAtc);
  }

  /* ---- reveals ---- */
  var rev = document.querySelectorAll('#dm140 [data-dmreveal]');
  if('IntersectionObserver' in window){
    var io2 = new IntersectionObserver(function(en){ en.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('in'); io2.unobserve(x.target); } }); }, {threshold:.15});
    rev.forEach(function(el){ io2.observe(el); });
  } else { rev.forEach(function(el){ el.classList.add('in'); }); }

  /* ---- count-up ---- */
  var num = $('dm-count');
  if(num){
    if(reduce || !('IntersectionObserver' in window)){ num.textContent = num.dataset.count; }
    else {
      var done = false;
      new IntersectionObserver(function(en, io){
        en.forEach(function(x){ if(x.isIntersecting && !done){ done = true; io.disconnect();
          var target = +num.dataset.count, t0 = null;
          function step(ts){ if(!t0) t0 = ts; var p = Math.min((ts - t0) / 1100, 1); var e = 1 - Math.pow(1 - p, 3); num.textContent = Math.round(target * e); if(p < 1) requestAnimationFrame(step); }
          requestAnimationFrame(step);
        }});
      }, {threshold:.5}).observe(num);
    }
  }

  /* ---- scroll-zoom story image ---- */
  var zimg = $('dm-zoomimg');
  if(zimg && !reduce){
    var zt = false;
    function zup(){
      zt = false;
      var r = zimg.getBoundingClientRect();
      var vh = window.innerHeight;
      var raw = 1 - (r.top + r.height * .5 - vh * .45) / (vh * .8);
      var p = Math.min(Math.max(raw, 0), 1);
      p = 1 - Math.pow(1 - p, 2);
      zimg.style.setProperty('--dmz', (0.88 + p * 0.12).toFixed(4));
    }
    window.addEventListener('scroll', function(){ if(!zt){ zt = true; requestAnimationFrame(zup); } }, {passive:true});
    zup();
  }

  /* ---- global FX ---- */
  if(!window.__awFx){
    window.__awFx = 1;
    if(fine && !reduce){
      document.addEventListener('mouseover', function(e){
        if(!e.target.closest) return;
        var m = e.target.closest('[data-aw-magnet]');
        if(m && !m.__mg){ m.__mg = 1; bindMag(m); }
        var t = e.target.closest('[data-aw-tilt]');
        if(t && !t.__tl){ t.__tl = 1; bindTilt(t); }
      });
    }
    function bindMag(btn){
      var bx=0,by=0,tx=0,ty=0,run=false;
      btn.addEventListener('mousemove', function(e){
        var r = btn.getBoundingClientRect();
        tx = (e.clientX - r.left - r.width/2) * .28;
        ty = (e.clientY - r.top - r.height/2) * .34;
        if(!run){ run = true; requestAnimationFrame(step); }
      });
      btn.addEventListener('mouseleave', function(){ tx = 0; ty = 0; });
      function step(){
        bx += (tx-bx)*.18; by += (ty-by)*.18;
        btn.style.transform = 'translate(' + bx.toFixed(1) + 'px,' + by.toFixed(1) + 'px)';
        if(Math.abs(tx-bx)>.2||Math.abs(ty-by)>.2||Math.abs(bx)>.2||Math.abs(by)>.2){ requestAnimationFrame(step); } else { run=false; btn.style.transform=''; }
      }
    }
    function bindTilt(card){
      card.addEventListener('mousemove', function(e){
        var r = card.getBoundingClientRect();
        var rx = ((e.clientY - r.top)/r.height - .5) * -6;
        var ry = ((e.clientX - r.left)/r.width - .5) * 6;
        card.style.transform = 'perspective(720px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) translateY(-6px)';
      });
      card.addEventListener('mouseleave', function(){ card.style.transform = ''; });
    }
  }

  /* ---- init ---- */
  if(D.hasColor){ setColor(state.c); }
  else { refreshSizes(); setSize(state.s); }
})();